import { Icon } from "@mui/material/styles/createTheme";

// Extend the MUI Icon type to include extraLarge
interface ExtendedIcon extends Icon {
  size: {
    default: {
      extraSmall: number;
      small: number;
      medium: number;
      large: number;
      extraLarge: number;
    };
    inline: {
      extraSmall: number;
      small: number;
      medium: number;
      large: number;
      extraLarge: number;
    };
  };
}

export const icon: ExtendedIcon = {
  size: {
    default: {
      extraSmall: 12,
      small: 16,
      medium: 20,
      large: 24,
      extraLarge: 40,
    },
    inline: {
      extraSmall: 16,
      small: 20,
      medium: 24,
      large: 28,
      extraLarge: 44,
    },
  },
};
